import {useAuth} from 'src/auth/context';
import {Divider, Menu, MenuItem, MenuProps, useTheme} from '@mui/material';
import {FC, useCallback} from 'react';
import {DefaultNavLink} from 'src/components/common/DefaultNavLink';
import {adminRoute} from 'src/routes';
import {compactInfoFontSize} from 'src/theme';

interface IDashboardLayoutSettingsMenuProps extends Omit<MenuProps, 'onClose'> {
  onClose: () => void;
}

export const SettingsMenu: FC<IDashboardLayoutSettingsMenuProps> = ({
  onClose,
  ...props
}) => {

  const theme = useTheme();

  const {logout} = useAuth();

  const handleLogout = useCallback(async () => {
    await logout();
    onClose();
  }, [onClose, logout]);

  return (
    <Menu
      {...props}
      onClose={onClose}
      keepMounted
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      style={{
        minWidth: '120px'
      }}
    >
      <MenuItem>
        <DefaultNavLink
          to={adminRoute}
        >
          Admin
        </DefaultNavLink>
      </MenuItem>

      <Divider />
      <MenuItem onClick={handleLogout}>Logout</MenuItem>
      <Divider />
    </Menu>
  );
};
